import noUiSlider from 'nouislider';

export default new class Filter {
    constructor() {
        this.init();
    }

    init() {

        this.filterFormList = document.querySelectorAll('form.filter-container');
        this.selectedList = document.querySelectorAll('a.selected-item');
        this.clearFilterButton = document.querySelector('.filter__clear');

        if(this.clearFilterButton != null) {
            this.clearFilter();
        }
        
        [...this.selectedList].forEach(item => {
            item.addEventListener('click', e => {
                const id = e.target.getAttribute('data-id');
                const element = document.getElementById(id);

                if(element.tagName === 'OPTION') {
                    console.log('option');
                    const select = element.parentNode;
                    element.remove();
                    select.dispatchEvent(new Event('change'));
                }

                if(element.tagName === 'INPUT') {
                    console.log('input');
                    element.click();
                }
            })
            
        });

        if(null == this.filterFormList)
            return;

        [...this.filterFormList].forEach(filterForm => {
            this.filterForm = filterForm;
            this.initFilterUI();
        });

        this.initSlider();
    }

    initFilterUI() {
        [...this.filterForm.elements].forEach(item => {

            if(item.tagName === 'BUTTON' && item.classList.contains(`view__toggle-btn`)) {
                item.addEventListener('click', () => {
                    this.changeView();
                });
            }

            if(item.tagName === 'SELECT') {
                item.addEventListener('change', () => {
                    this.send();
                });
            }

            if(item.tagName === 'INPUT') {
                if(item.type === 'checkbox') {
                    item.addEventListener('change', () => {
                        this.send();
                    });
                }

                if(item.type === 'number') {
                    let delay = this.makeDelay(400);
                    item.addEventListener('keyup', () => {
                        delay(() => {
                            this.send();
                        });
                    });
                }
            }
                
        });
    }

    // clear filters
    clearFilter() {
        this.clearFilterButton.addEventListener('click', () => {

            let formData = new FormData();
            let data = Object.fromEntries(formData);

            this.pushUrl(formData);

            const that = this;
            oc.ajax('onFilter', {
                data: data, 
                success: function success(data) {
                    this.success(data).done(() => {
                        that.init();
                    });
                }
            });
        });
    }

    initSlider() {
        const range = document.querySelector('#price-range');

        if(null == range)
            return;

        this.handles = {
            0: 'min',
            1: 'max',
        };

        this.inputField = {
            min: document.querySelector('#min-price'),
            max: document.querySelector('#max-price'),
        };

        this.min = this.inputField.min.getAttribute('min');
        this.max = this.inputField.max.getAttribute('max');

        this.from = this.inputField.min.value ? this.inputField.min.value : this.min;
        this.to = this.inputField.max.value ? this.inputField.max.value : this.max;
    
        noUiSlider.create(range, {
            start: [
              this.from,
              this.to,
            ],
            connect: true,
            range: {
              min: parseInt(this.min, this.iRadix),
              max: parseInt(this.max, this.iRadix),
            },
        }).on('change', (values, handle) => {
            this.handleChange(values, handle);
        });
    }

    handleChange(values, handle) {
        this.inputField[this.handles[handle]].value = values[handle];
        this.send();
    }

    pushUrl(formData) {

        let searchParams = new URLSearchParams(formData);

        searchParams = this.queryHandle(searchParams);

        const queryString = decodeURI(searchParams.toString());
        history.pushState(null, null, `${this.filterForm.action}${queryString ? '?' + queryString : '' }`);
    }

    send() {

        let formData = new FormData();
        [...this.filterFormList].forEach(filterForm => {

            const form = new FormData(filterForm);

            [...form.entries()].forEach(item => {

                if(item[1]) {
                    formData.append(item[0], item[1]);
                }

            });

        });

        let data = Object.fromEntries(formData);

        this.pushUrl(formData);

        const that = this;
        oc.ajax('onFilter', {
            data: data, 
            success: function success(data) {
                this.success(data).done(() => {
                    that.init();

                    scrollTo('h1', 20);      
                });
            }
        })
    }

    changeView() {
        const that = this;
        oc.ajax('onChangeView', {
            success: () => {
                that.send();
            }
        });
    }

    queryHandle(searchParams) {

        this.unsetDefaultValues(searchParams)

        // query to seo
        let listParams = searchParams;

        let arr = [];
        [...listParams.keys()].forEach(function(key) {
            if(key.match(/filter_form/)) {
                arr.push([key, searchParams.get(key)]);
                //console.log(key, searchParams.get(key));
                searchParams.delete(key);
            }
            
        });

        let delimeter = '--';
        let result = [];
        arr.forEach((section) => {
            let property = false;
            let brand = false;

            const param = section[0];
            const value = section[1];

            let row = [];

            let m = [];
            param.replace(/\[(.*?)\]/g, function(g0,g1){
                m.push(g1);
            });

            let param_id = m[1];

            const propertyMathes = m[0].match(/(property.)([0-9^]+)/);

            if(propertyMathes) {
                property = true;
                console.log(propertyMathes[2]);
                row.push("p" + propertyMathes[2]);
            } else {
                brand = true;
                row.push("brand");
            }

            if(param_id) {
                row.push('~' + param_id);
            }

            row.push(delimeter + value);

            result.push(row.join(''));
        });

        searchParams.delete('q');

        if(result.length) {
            searchParams.append('q', result.join('_'));
        }

        return searchParams;
    }

    unsetDefaultValues(searchParams) {
        // remove default values
        const sortField = 'sort';
        const limitField = 'limit';

        const priceFromField = 'price_form[from]';
        const priceToField = 'price_form[to]';

        const priceMinField = 'price_form[min]';
        const priceMaxField = 'price_form[max]';

        if(parseInt(searchParams.get(priceFromField)) == searchParams.get(priceMinField)) {
            searchParams.delete(priceFromField);
        }

        if(parseInt(searchParams.get(priceToField)) == searchParams.get(priceMaxField)) {
            searchParams.delete(priceToField);
        }

        if(searchParams.get(sortField) == 'order|asc') {
            searchParams.delete(sortField);
        }

        if(searchParams.get(limitField) == '12') {
            searchParams.delete(limitField);
        }

        searchParams.delete(priceMinField);
        searchParams.delete(priceMaxField);

        return searchParams;
    }

    // helper delay function
    makeDelay(ms) {
        var timer = 0;
        return function(callback){
            clearTimeout (timer);
            timer = setTimeout(callback, ms);
        };
    };
}